var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartcircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14909",
    "data-name": "Group 14909",
    transform: "translate(-1406 -88)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1406 88)",
    fill: "#ff5e15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shopping-basket",
    transform: "translate(1416 68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33862",
    "data-name": "Path 33862",
    d: "M19.461,36.874H17.394l-4.523-5.653a.587.587,0,0,0-.917.734l3.935,4.919H4.159l3.936-4.919a.587.587,0,1,0-.917-.734L2.655,36.874H.587A.587.587,0,0,0,0,37.461v1.175a.587.587,0,0,0,.587.587H19.461a.587.587,0,0,0,.587-.587V37.461a.587.587,0,0,0-.587-.587Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33863",
    "data-name": "Path 33863",
    d: "M35.914,278.8a.587.587,0,0,0,.565.426H48.3a.587.587,0,0,0,.565-.426L51.1,271H33.686Zm9.168-2.607.587-3.524a.587.587,0,1,1,1.159.193l-.587,3.524a.587.587,0,0,1-1.159-.193ZM41.8,272.762a.587.587,0,1,1,1.175,0v3.524a.587.587,0,1,1-1.175,0Zm-3.327-.579a.587.587,0,0,1,.676.483l.587,3.524a.587.587,0,1,1-1.159.193l-.587-3.524A.587.587,0,0,1,38.477,272.183Z",
    transform: "translate(-32.367 -230.602)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartcircle);
export default __webpack_public_path__ + "static/media/cartcircle.2d1afb821c7be0aa6ab0f007a532d39f.svg";
export { ForwardRef as ReactComponent };